// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
// import "@hotwired/turbo-rails"
// import "controllers"

import '../assets/javascripts/application-original.js'

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

// Import and register Stimulus controller
import { Application } from "@hotwired/stimulus"
import LogoutController from "./controllers/logout_controller"
import UnpublishController from "./controllers/unpublish_controller"
import LoadMoreController from "./controllers/load_more_controller"
import DonationTypeController from "./controllers/donation_type_controller"

window.Stimulus = Application.start()
Stimulus.register("logout", LogoutController)
Stimulus.register("unpublish", UnpublishController)
Stimulus.register("load-more", LoadMoreController)
Stimulus.register("donation-type", DonationTypeController)

// TODO: need to work through and get the direct upload working across all of the forms
// see https://guides.rubyonrails.org/active_storage_overview.html#direct-uploads
// Maybe look at replacing the functionality of cocoon with a Stimulus controller that adds / removes etc